import { render } from "./GridCardsServicosAptSimultaneo.vue?vue&type=template&id=1ff1f406&scoped=true"
import script from "./GridCardsServicosAptSimultaneo.vue?vue&type=script&lang=js"
export * from "./GridCardsServicosAptSimultaneo.vue?vue&type=script&lang=js"

import "./GridCardsServicosAptSimultaneo.vue?vue&type=style&index=0&id=1ff1f406&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff1f406"]])

export default __exports__